// extracted by mini-css-extract-plugin
export default {"container":"image_container__2xUys","inner":"image_inner__2T6s2"};